import { Component, ComponentPublicInstance, createApp, WatchCallback, WatchSource, WatchStopHandle } from 'vue';
import Oruga from '@oruga-ui/oruga-next';
import { bulmaConfig } from '@oruga-ui/theme-bulma'
import { createRouter, createWebHistory } from 'vue-router'
import '@oruga-ui/theme-bulma/dist/bulma.css'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import App from './App.vue'
import searchComponent from './components/search/citation-search.vue';
import searchResultsComponent from './components/search/citation-search-results.vue';
import createAccountComponent from './components/CreateAccount/create-account.vue';
import loginPageComponent from './components/LoginPage/login-page.vue';
import userPageComponent from './components/UserPage/user-page.vue';
import paymentLoginCheck from './components/payment/payment-login-check.vue';
import paymentInfoComponent from './components/payment/collect-payment-info.vue';
import accountManagmentComponent from './components/AccountManagment/account-managment.vue';
import receiptReportComponent from './components/Reports/ReceiptReport/receipt-report.vue';
import pastPayments from './components/Past-Payments/past-payments.vue';
import paymentConfirmationComponent from './components/payment/payment-confirmation.vue';
import changePasswordComponent from './components/LoginPage/change-password.vue';
import forgotPasswordComponent from './components/LoginPage/forgot-password.vue';

import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { useUserStore } from './stores/user';
import { vMaska } from "maska";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSearch, faCircleSmall, faCircleInfo, faTimes, faCheck, faArrowUp, faExclamationCircle, faCircleX, faEnvelope, faEye, faEyeSlash, faCircleCheck, faSpinner, faSyncAlt, faArrowLeft, faCircleNotch } from '@fortawesome/pro-solid-svg-icons';
import "devextreme/dist/css/dx.light.css";
import "@devexpress/analytics-core/dist/css/dx-analytics.common.css";
import "@devexpress/analytics-core/dist/css/dx-analytics.light.css";
import "@devexpress/analytics-core/dist/css/dx-querybuilder.css";
import "devexpress-reporting/dist/css/dx-webdocumentviewer.css";
import "devexpress-reporting/dist/css/dx-reportdesigner.css";
import axios from './plugins/axios.plugin'

library.add(
    faSearch,
    faCircleSmall,
    faCircleInfo,
    faTimes,
    faCheck,
    faArrowUp,
    faExclamationCircle,
    faArrowLeft,
    faCircleX,
    faEnvelope,
    faEye,
    faEyeSlash,
    faCircleCheck,
    faSpinner,
    faSyncAlt,
    faCircleNotch
);

bulmaConfig.iconComponent = "vue-fontawesome";
bulmaConfig.iconPack = "fas";

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

//Route
const routes = [
    { path: '/', name: 'search', component: searchComponent },
    { path: '/results', name: 'results', component: searchResultsComponent },
    { path: '/payment-login', name: 'paymentLoginCheck', component: paymentLoginCheck },
    { path: '/payment-info', name: 'paymentInfo', component: paymentInfoComponent },
    { path: '/create-account', name: 'create account', component: createAccountComponent },
    { path: '/login', name: 'login', component: loginPageComponent },
    { path: '/user', name: 'user', component: userPageComponent },
    { path: '/account-managment', name: 'account management', component: accountManagmentComponent },
    { path: '/receipt-report', name: 'receiptReport', component: receiptReportComponent },
    { path: '/past-payment', name: 'pastPayments', component: pastPayments },
    { path: '/payment-confirmation/', name: 'paymentConfirmation', component: paymentConfirmationComponent },
    { path: '/forgot-password', name: 'forgot-password', component: forgotPasswordComponent },
    { path: '/change-password', name: 'changePassword', component: changePasswordComponent },
    { path: '/reset-password', redirect: '/change-password' }
]

type formWithFormWatcherAndFormChanges = {
    FormChanges: Array<string>,
    FormWatchers: Array<WatchStopHandle>,
} & {
    [x: string | number | symbol]: unknown
}

interface functions {
    formWatch: (form: formWithFormWatcherAndFormChanges, componentPublicInstance: ComponentPublicInstance, removeWatch: boolean) => void
}

const formWatch = function (form: formWithFormWatcherAndFormChanges, componentPublicInstance: ComponentPublicInstance, removeWatch: boolean): void {
    if (!removeWatch) {
        form.FormChanges = [];
        form.FormWatchers = [];

        Object.keys(form).forEach(key => {

            if (key !== "FormChanges" && key !== "FormWatchers") {

                const unwatch = componentPublicInstance.$watch(
                    () => form[key],
                    () => {
                        const exists: boolean = form.FormChanges.includes(`${key}`);

                        if (!exists) {
                            form.FormChanges.push(key);
                        }
                    }
                );

                form.FormWatchers.push(unwatch);
            }
        })
    } else {
        for (let i = 0; i < form.FormWatchers.length; i++) {
            form.FormWatchers[i]();
        }
    }
}

const functions: functions = {
    formWatch: formWatch
};

const router = createRouter({
    history: createWebHistory('/PayTickets/'),
    routes,
})

const app = createApp(App);

app.provide('$functions', functions);

app.component("vue-fontawesome", FontAwesomeIcon)
    .use(Oruga, bulmaConfig)
    .use(router)
    .use(pinia)
    .use(axios, {
        baseUrl: '/PayTickets/api'
    })
    .mount('#app')

app.directive("maska", vMaska);